import {ILegendItem} from '../sfa-header/sfa-header.service';
import {FL_ENDING_TYPE} from '../sfa-header/header.model';

export interface IDynamicFLStyle {
  height: string;
  width: string;
  'margin-right'?: string;
  'margin-left'?: string;
  '--fill-color'?: string;
  '--stroke-color'?: string;
}

export class FlowlineHeaderHelper {
  public getDynamicStyle(item: ILegendItem): (endType: FL_ENDING_TYPE, isStart: boolean) => any {
    return (endType, isStart) => {
      const marginType = isStart ? 'margin-right' : 'margin-left';
      const color = item.style.borderColor;

      switch (endType) {
        case 'classic':
          return this._classic(color, marginType);

        case 'diamond':
          return this._diamond(color, marginType);

        case 'blockThin':
          return this._blockThin(color, marginType);

        case 'ERone':
          return this._ERone(color, marginType);

        case 'ERmany':
          return this._ERmany(color, marginType);

        case 'ERmandOne':
          return this._ERmandOne(color, marginType);

        case 'ERoneToMany':
          return this._ERoneToMany(color, marginType);

        case 'ERzeroToOne':
          return this._ERzeroToOne(color, marginType);

        case 'ERzeroToMany':
          return this._ERzeroToMany(color, marginType);
      }

      return null;
    };
  }

  private _classic(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '16px',
      [marginType]: '-3px',
      '--fill-color': color
    };
  }

  private _diamond(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '24px',
      width: '24px',
      [marginType]: '-6px',
      '--stroke-color': color
    };
  }

  private _blockThin(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '16px',
      [marginType]: '0',
      '--fill-color': color
    };
  }

  private _ERone(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '13px',
      [marginType]: '-1px',
      '--stroke-color': color
    };
  }

  private _ERmany(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '16px',
      [marginType]: '-3px',
      '--stroke-color': color,
      '--fill-color': '#fff'
    };
  }

  private _ERmandOne(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '16px',
      [marginType]: '-1px',
      '--stroke-color': color
    };
  }

  private _ERoneToMany(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '16px',
      width: '16px',
      [marginType]: '-1px',
      '--stroke-color': color,
      '--fill-color': '#fff'
    };
  }

  private _ERzeroToOne(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '24px',
      width: '24px',
      [marginType]: '-1px',
      '--stroke-color': color,
      '--fill-color': '#fff'
    };
  }

  private _ERzeroToMany(color: string, marginType: string): IDynamicFLStyle {
    return {
      height: '24px',
      width: '24px',
      [marginType]: '-1px',
      '--stroke-color': color,
      '--fill-color': '#fff'
    };
  }
}
